"use strict"

import asyncAppend from "@elements/async-append";
import fetch from "@elements/fetch"

export function initInScope ($scope) {
    let modal = $scope.find('.js-fetch-modal-toggle').attr('data-target');

    $scope.find('.js-fetch-modal-toggle').on("click", function(){
        //url auf content file
        let url = $scope.find('.js-fetch-modal-toggle').attr('data-content-url');
        let content =  $('.js-fetch-modal__content');
        let loading =  $('.js-fetch-modal__loading');
        let notification =  $('.js-fetch-modal__notification')

        asyncAppend({
                $target: content,
                $loading: loading,
                $notifications: notification
            }, fetch( url,
                {
                    method: 'GET',
                    headers: {
                        'X-Requested-With' : 'XMLHttpRequest',
                        'Content-Type': 'application/json'
                    }
                })
        );
    });

    $scope.find('.js-fetch-modal-toggle').on('hidden.bs.modal', function(){
        $('.js-fetch-modal__content');
    })
}